;(function () {

"use strict";

var SocialMediaView = require('../views/social-media');

var PinterestView = Backbone.View.extend({
  initialize: function () {
    // console.log('pinterest view initialized');
    this.media = this.$el.attr('src');
    this.description = this.$el.attr('alt') || $('meta[property="og:description"]').attr('content');
    this.href = window.location.href;

    this.$span = $("<span>");
    this.$a = $('<a class="pinterest" href="http://pinterest.com/pin/create/button/?url='+this.href+'&media='+this.media+'&description='+this.description+'" target="_blank">');

    this.$el.wrap($('<div class="pinterest-wrapper">'));
    this.$el.wrap(this.$span);

    var self = this;
    _.defer(function () {
      self.$a.insertAfter(self.$el);
    })

    this.$a.on('click', function (e) {
      window.open("http://pinterest.com/pin/create/button/?url="+self.href+"&media="+self.media+"&description="+self.description, '_blank', "status = 1, height = 420, width = 550");
      return false;
    });
  }
})

var HeaderPinterestView = Backbone.View.extend({
  initialize: function () {
    // console.log('header pinterest view initialized');
    this.media = this.$el.find('img').last().attr('src');
    this.description = this.$el.find('img').last().attr('alt') || $('meta[property="og:description"]').attr('content');
    this.href = window.location.href;

    this.$a = $('<a class="pinterest" href="http://pinterest.com/pin/create/button/?url='+this.href+'&media='+this.media+'&description='+this.description+'" target="_blank">');

    this.$el.append(this.$a);

    this.$el.addClass('header-pinterest-wrapper');

    var self = this;
    this.$a.on('click', function (e) {
      window.open("http://pinterest.com/pin/create/button/?url="+self.href+"&media="+self.media+"&description="+self.description, '_blank', "status = 1, height = 420, width = 550");
      return false;
    });
  }
})

var PageView = Backbone.View.extend({
  initialize: function () {
    // console.log('initialized article view');
    new SocialMediaView({ el: $('ul.share-post') });

    new HeaderPinterestView({ el: this.$el.find('.main-content > .article > .content-wrapper > .img.lazy-load').first() });

    this.$el.find('.main-content > .article .content img').each(function () {
      // console.log('image');
      // console.log(this);
      new PinterestView({ el: this });
    });
  }
});

module.exports = PageView;

}());